// Validation limits
export const STATE_ALLOCATION_VALIDATION_LIMITS = {
  PROJECT_NAME_MIN_LENGTH: 3,
  PROJECT_NAME_MAX_LENGTH: 200,
  AMOUNT_MIN: 0,
  AMOUNT_MAX: 999999,
  FUNDING_PATTERN_MAX_LENGTH: 20
};

export const DEFAULT_FUNDING_PATTERN = "";

// Default project allocation with lock fields
export const DEFAULT_PROJECT_ALLOCATION = {
  department: '',
  projectName: '',
  installment: 1,
  approvedAllocation: 0,
  clearedAgainstAllocation: 0,
  clearedFromCommonPool: 0,
  additionalStateShare: 0,
  totalAmount: 0,
  fundingPattern: DEFAULT_FUNDING_PATTERN,
  correspondingCentralShare: 0,
  balanceStateShareAgainstAllocation: 0,
  financialYear: '',
  // Project-level lock fields
  isLocked: false,
  lockedAt: null,
  lockedBy: null,
  lockedByName: null
};

// Format amount
export const formatAllocationAmount = (amount) => {
  if (!amount && amount !== 0) return '₹0.00';
  const numAmount = parseFloat(amount);
  if (isNaN(numAmount)) return '₹0.00';
  return `₹${numAmount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

// Calculate total amount
export const calculateTotalAmount = (clearedAgainstAllocation, clearedFromCommonPool, additionalStateShare) => {
  const cleared = parseFloat(clearedAgainstAllocation) || 0;
  const commonPool = parseFloat(clearedFromCommonPool) || 0;
  const additional = parseFloat(additionalStateShare) || 0;
  return cleared + commonPool + additional;
};

// Calculate balance
export const calculateBalanceAgainstAllocation = (approvedAllocation, clearedAgainstAllocation) => {
  const approved = parseFloat(approvedAllocation) || 0;
  const cleared = parseFloat(clearedAgainstAllocation) || 0;
  return Math.max(0, approved - cleared);
};

// Format funding pattern
export const formatFundingPattern = (pattern) => {
  if (!pattern || pattern === "") return "—";
  return pattern;
};

// Validate funding pattern
export const isValidFundingPattern = (pattern) => {
  if (!pattern || pattern.trim() === "") return true;
  const ratioPattern = /^(\d+)(:(\d+))*$/;
  return ratioPattern.test(pattern.trim());
};